<script setup lang="ts">
import store from "@/store";
import { baseHeader, sideMenu, fullLoading } from "@/common/components";

interface MenuListType {
  icon: string;
  label: string;
  url: string;
  disabled?: boolean;
}

defineProps<{
  menuList: MenuListType[];
}>();
</script>

<template>
  <section class="screen">
    <side-menu :menus="menuList" background="#fff" />
    <section class="pages">
      <base-header background="#fff" />
      <main class="main">
        <slot name="main"></slot>
      </main>
    </section>
    <full-loading v-if="store.getters.loading" />
  </section>
</template>

<style lang="scss" scoped>
.screen {
  display: grid;
  width: 100%;
  height: 100dvh;
  grid-template-columns: auto 1fr;

  .pages {
    display: flex;
    flex-direction: column;

    main {
      display: flex;
      flex-direction: column;
      padding-block: 1.5rem;
      padding-inline: 1.5rem;
      height: calc(100dvh - 4rem);
      overflow-y: auto;
    }
  }
}
</style>
